import * as React from "react";
import type { BaseIconProps } from "../../Icon.types";

export function ReportsIcon({ size = 18, color, strokeColor, fillColor, className }: BaseIconProps) {
  const stroke = strokeColor ?? color ?? "currentColor";
  const fill = fillColor ?? "none";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  );
}
